// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","color-black":"#000000","colorBlack":"#000000","buttonBuyNow":"_2c3wZ","buttonMultiply":"_1TYxF"};